import { FeedSortMode } from '../types';

export const getFeedSortModeName = (option: FeedSortMode): string => {
    switch (option) {
        case FeedSortMode.New:
            return 'New';
        case FeedSortMode.Random:
            return 'Random';
        case FeedSortMode.TopAllTime:
            return 'Top All Time';
        case FeedSortMode.TopThisMonth:
            return 'Top This Month';
        case FeedSortMode.TopThisWeek:
            return 'Top This Month';
        case FeedSortMode.TopThisYear:
            return 'Top This Year';
        case FeedSortMode.Trending:
            return 'Trending';
    }
};
